import PlayerGame from '@/components/Student/PlayerGame'

const PlayerGameScreen = () => {
  return <PlayerGame />
}

export default PlayerGameScreen
